import { Card } from "antd";

import { Activity } from "components/lists/activities/list";

import { styles } from "./styles";

export const LatestActivity = (props) => {
  const { activity } = props;

  if (!activity) {
    return null;
  }

  return (
    <div style={styles.infoCard.container}>
      <strong style={styles.infoCard.title}>Latest Activity</strong>
      <Card style={styles.infoCard.body}>
        <Activity activity={activity} />
      </Card>
    </div>
  );
};
